import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import MandateTable from '@accounting/components/tables/mandate-table/mandate-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcDirectDebitFilesTabs from '@accounting/components/tabs/direct-debit-files/direct-debit-files-tabs.vue';

@Component({
  name: 'bpc-mandates',
  components: {
    'bpc-mandate-table': MandateTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-direct-debit-files-tabs': BpcDirectDebitFilesTabs,
  },
})
export default class Mandates extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
